<div class="app-search">
    <div class="search-box flex-grow-1">
        <input type="text" name="searchTerm" class="form-control search border-light" 
            placeholder="{{searchPlaceHolderText}}" [(ngModel)]="searchTerm" (keyup)="search()">
        <span class="mdi mdi-magnify search-widget-icon" ></span>
        <span *ngIf="searchTerm" class="mdi mdi-close-circle search-widget-icon search-widget-icon-close " (click)="clearSearch()"></span>
    </div>
    <div class="dropdown-menu dropdown-menu-lg" id="search-dropdown" style="width: 350px;">
        <div
            *ngIf="securityPermissionClientSearch === false && securityPermissionRequisitionSearch === false && securityPermissionContactSearch === false && securityPermissionUserSearch === false ">
            <div _ngcontent-acb-c193="" id="alerts-tab" role="tabpanel" aria-labelledby="alerts-tab"
                class="tab-pane p-4">
                <div class="text-center pb-5 mt-2">
                    <lord-icon src="https://cdn.lordicon.com/msoeawqm.json" trigger="hover"
                        colors="primary:#121331,secondary:#08a88a" style="width:150px;height:150px">
                    </lord-icon>
                    <h6 class="fs-18 fw-semibold lh-base">No Results found</h6>
                </div>
            </div>
        </div>
        <ngx-simplebar>
            <div *ngIf="securityPermissionRequisitionSearch">
                <div class="dropdown-header mb-0 pb-0" style="display: flex; justify-content: space-between;">
                    <h6 class="text-overflow text-muted mb-2 text-uppercase">Requisitions</h6>
                    <button *ngIf="securityPermissionRequisitionCreate && !clientListLoading"
                        class="btn badge bg-light text-primary fs-12 "
                        style="top: -0.5rem; border-color:var(--vz-btn-disabled-border-color)"
                        (click)="openModalNew(entityTypeEnum.Requisition)">
                        <div style="display: inline-flex; ">
                            <i class="ri-add-fill align-bottom me-1"></i>
                            <div style="text-align: center;" i18n="@@">New</div>
                        </div>
                    </button>
                </div>
                <div style="padding-left: 0.5rem;">
                    <div style="max-height: 190px; overflow: scroll; border-radius: var(--vz-card-border-radius); ">
                        <table class=" align-middle table-nowrap pb-0 mb-0" style="border-radius: 0.25rem; width: 100%;">
                            <tbody class="list form-check-all" style="cursor:default; background-color: var(--vz-footer-bg); border-color: inherit; margin-right: 0.5rem !important;
                                display: block;">
                                <tr class="dropdown-item" style="display: inline-table; "
                                    style="border-top-left-radius: 0.5rem; border-left-style: solid; border-left-width: 0.5rem;border-bottom-left-radius: 0.5rem; cursor: pointer;"
                                    style=" border-left-color: {{styleRowStatus(data)}}"
                                    *ngFor="let data of requisitionListItems" id="i_{{data.id}}"
                                    (click)="openModalEdit(entityTypeEnum.Requisition, data.id)">
                                    <td style="width: 0px; border-bottom-width: 0px;">
                                        <div class="d-flex align-items-center gap-2">
                                            <div class="flex-shrink-0">
                                                <img src='{{data.listPhoto}}' class=" avatar-xs rounded-circle p-0 m-0">
                                            </div>
                                            <div>
                                                <div *ngIf="data.number">
                                                    {{data.number}}
                                                </div>
                                                <p class="mb-0 fs-12 text-muted">
                                                    <span *ngIf="data.matterNumber"
                                                        i18n="@@Modal_Requisition_Body_MatNum">
                                                        Mat#</span>
                                                    <span *ngIf="data.matterNumber else elseNoMatter">
                                                        {{data.matterNumber}}
                                                    </span>
                                                    <ng-template #elseNoMatter>
                                                        <strong style="color: #ed5e5e;">No Matter</strong>
                                                    </ng-template>
                                                </p>
                                            </div>
                                        </div>
                                    </td>
                                    <td style="border-bottom-width: 0px;">
                                        <div class="d-flex align-items-center">

                                            <div>
                                                <div *ngIf="data.client else elseNoClient">
                                                    {{data.client.fullName}}
                                                </div>

                                                <ng-template #elseNoClient>
                                                    <strong style="color: #ed5e5e;">No Client</strong>
                                                </ng-template>


                                                <p class="mb-0 fs-12 text-muted">
                                                    <span *ngIf="data.account else elseNoAccountName">
                                                        {{data.account.fullName}}
                                                    </span>

                                                    <ng-template #elseNoAccountName>
                                                        <strong style="color: #ed5e5e;">No Contact</strong>
                                                    </ng-template>
                                                </p>
                                            </div>
                                        </div>
                                    </td>

                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div *ngIf="securityPermissionClientSearch">
                <div class="dropdown-header mt-2 mb-0 pb-0" style="display: flex; justify-content: space-between;">
                    <h6 class="text-overflow text-muted mb-2 text-uppercase">Clients</h6>
                    <button *ngIf="securityPermissionClientCreate && !clientListLoading"
                        class="btn badge bg-light text-primary fs-12 "
                        style="top: -0.5rem; border-color:var(--vz-btn-disabled-border-color)"
                        (click)="openModalNew(entityTypeEnum.Client)">
                        <div style="display: inline-flex; ">
                            <i class="ri-add-fill align-bottom me-1"></i>
                            <div style="text-align: center;" i18n="@@">New</div>
                        </div>
                    </button>
                </div>
                <div style="max-height: 150px; overflow: scroll;">
                    <div class="px-2">
                        <div class="card card-no-border" id="draftList" style="margin-bottom: 0;">
                            <div class="dropdown-item " style="cursor: pointer;" *ngFor="let data of clientListItems"
                                id="item_{{data.id}}">
                                <div class="d-flex align-items-center"
                                    (click)="openModalEdit(entityTypeEnum.Client, data.id)">
                                    <div class="d-flex align-items-center"
                                        style="overflow: hidden;text-overflow: ellipsis; width: 100%;">
                                        <div class="flex-shrink-0 gap-2">
                                            <img [src]="data.listPhoto" alt="" class=" avatar-xs rounded-circle me-2">
                                        </div>

                                        <div class="text-decoration-underline" style="color: var(--vz-link-color);">
                                            {{data.name + " "+ (data.lastName||" ")}}
                                        </div>
                                        <div class="px-3">
                                            {{data.email}}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="securityPermissionContactSearch">
                <div class="dropdown-header mt-2 mb-0 pb-0" style="display: flex; justify-content: space-between;">
                    <h6 class="text-overflow text-muted mb-2 text-uppercase">Contacts</h6>
                    <button *ngIf="securityPermissionContactCreate && !contactListLoading"
                        class="btn badge bg-light text-primary fs-12 "
                        style="top: -0.5rem; border-color:var(--vz-btn-disabled-border-color)"
                        (click)="openModalNew(entityTypeEnum.Account)">
                        <div style="display: inline-flex; ">
                            <i class="ri-add-fill align-bottom me-1"></i>
                            <div style="text-align: center;" i18n="@@">New</div>
                        </div>
                    </button>
                </div>
                <div style="max-height: 150px; overflow: scroll;">
                    <div class="px-2">
                        <div class="card card-no-border" id="draftList" style="margin-bottom: 0;">
                            <div class="dropdown-item " style="cursor: pointer;" *ngFor="let data of contactListItems"
                                id="item_{{data.id}}">
                                <div class="d-flex align-items-center"
                                    (click)="openModalEdit(entityTypeEnum.Account, data.id)">
                                    <div class="d-flex align-items-center"
                                        style="overflow: hidden;text-overflow: ellipsis; width: 100%;">
                                        <div class="flex-shrink-0 gap-2">
                                            <img [src]="data.listPhoto" alt="" class=" avatar-xs rounded-circle me-2">
                                        </div>
                                        <div class="text-decoration-underline" style="color: var(--vz-link-color);">
                                            {{data.fullName}}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="securityPermissionUserSearch">
                <div class="dropdown-header mt-2 mb-0 pb-0" style="display: flex; justify-content: space-between;">
                    <h6 class="text-overflow text-muted mb-2 text-uppercase">Users</h6>
                    <button *ngIf="securityPermissionUserCreate && !userListLoading"
                        class="btn badge bg-light text-primary fs-12 "
                        style="top: -0.5rem; border-color:var(--vz-btn-disabled-border-color)"
                        (click)="openModalNew(entityTypeEnum.User)">
                        <div style="display: inline-flex; ">
                            <i class="ri-add-fill align-bottom me-1"></i>
                            <div style="text-align: center;" i18n="@@">New</div>
                        </div>
                    </button>
                </div>
                <div style="max-height: 150px; overflow: scroll;">
                    <div class="px-2">
                        <div class="card card-no-border" id="draftList" style="margin-bottom: 0;">
                            <div class="dropdown-item " style="cursor: pointer;" *ngFor="let data of userListItems"
                                id="item_{{data.id}}">
                                <div class="d-flex align-items-center"
                                    (click)="openModalEdit(entityTypeEnum.User, data.id)">
                                    <div class="d-flex align-items-center"
                                        style="overflow: hidden;text-overflow: ellipsis; width: 100%;">
                                        <div class="flex-shrink-0 gap-2">
                                            <img [src]="data.listPhoto" alt="" class=" avatar-xs rounded-circle me-2">
                                        </div>
                                        <div class="text-decoration-underline" style="color: var(--vz-link-color);">
                                            {{data.fullName}}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ngx-simplebar>
        <div *ngIf="contactListLoading || clientListLoading || userListLoading || requisitionListLoading"
            id="elmLoader">
            <div class="spinner-border text-primary avatar-sm" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
    </div>
</div>